import { z } from "zod";

import { zOptions } from "./dataTypes";

export const zCompInput = z
  .object({
    type: z.literal("Input"),
    maxLength: z.number().int().min(1).nullish(),
    addonAfter: z.string().nullish().describe("Шаблон"),
  })
  .describe("Input из Ant design. Для данных типа string");
export type ZCompInput = z.infer<typeof zCompInput>;

export const zCompInputNumber = z
  .object({
    type: z.literal("InputNumber"),
    min: z.number().nullish(),
    max: z.number().nullish(),
    precision: z
      .number()
      .int()
      .min(0)
      .max(12)
      .nullish()
      .describe("Число десятичных знаков после запятой"),
    addonAfter: z.string().nullish().describe("Шаблон"),
  })
  .describe("InputNumber из Ant design. Для данных типа number");
export type ZCompInputNumber = z.infer<typeof zCompInputNumber>;

export const zCompCheckbox = z
  .object({
    type: z.literal("Checkbox"),
  })
  .describe("Checkbox из Ant design. Для данных типа bool");
export type ZCompCheckbox = z.infer<typeof zCompCheckbox>;

export const zCompSelect = z
  .object({
    type: z.literal("Select"),
    options: zOptions.nullish(),
  })
  .describe(
    "Select из Ant design. Может быть использован для разных типов данных, но предпочтительно strOption",
  );
export type ZCompSelect = z.infer<typeof zCompSelect>;

export const zCompDate = z.object({
  type: z.literal("Date"),
  placeholder: z.string().nullish(),
});
export type ZCompDate = z.infer<typeof zCompDate>;
